import { z } from "zod";

export const serviceCoverageModeValues = [
  "ad_hoc_only",
  "included_allowance",
  "included_allowance_with_overage",
  "fixed_fee_included",
  "fully_non_billable",
] as const;

export const serviceCollectionMethodValues = [
  "manual_invoice",
  "stripe_invoice",
  "stripe_autocharge",
] as const;

export const serviceCoverageModeSchema = z.enum(serviceCoverageModeValues);
export const serviceCollectionMethodSchema = z.enum(
  serviceCollectionMethodValues,
);
export const recurringBillingQueueStatusValues = [
  "pending",
  "emailed",
  "paid",
  "failed",
  "cancelled",
] as const;
export const recurringBillingQueueStatusSchema = z.enum(
  recurringBillingQueueStatusValues,
);

export const recurringBillingQueueItemSchema = z.object({
  id: z.string().uuid(),
  serviceId: z.string().uuid(),
  invoiceId: z.string().uuid().nullable(),
  clientId: z.string().uuid(),
  clientName: z.string().min(1),
  productId: z.string().uuid(),
  productName: z.string().min(1),
  serviceName: z.string().min(1),
  currency: z.string().length(3),
  amount: z.string(),
  dueAt: z.coerce.date(),
  status: recurringBillingQueueStatusSchema,
  collectionMethod: serviceCollectionMethodSchema,
  lastReminderAt: z.coerce.date().nullable(),
});

export type ServiceCoverageMode = z.infer<typeof serviceCoverageModeSchema>;
export type ServiceCollectionMethod = z.infer<
  typeof serviceCollectionMethodSchema
>;
export type RecurringBillingQueueStatus = z.infer<
  typeof recurringBillingQueueStatusSchema
>;
export type RecurringBillingQueueItem = z.infer<
  typeof recurringBillingQueueItemSchema
>;
